import { Component, Input } from '@angular/core';

import { FirebaseService } from '../../services/firebase.service';

@Component({
  selector    : 'new-item',
  templateUrl : 'new-item.html',
  styleUrls   : [ 'new-item.scss' ]
})

export class NewItemComponent {
  @Input() isList : boolean;
  @Input() title  : string;

  newItem    : string;
  recipe     : string;
  saveRecipe : boolean = true;
  bulk       : boolean = false;

  constructor(
    public firebaseService : FirebaseService
  ) {
    this.isFirstTimeUser();
  }

  isFirstTimeUser(counter : number = 0) : void {
    if (this.firebaseService.items) {
      this.firebaseService.items
        .map(items => !!items.length)
        .take(1)
        .subscribe(hasItems => {
          // if (!hasItems)
          //   this.newItem = '5 example apples';
        });
    } else if (counter++ < 100) {
      setTimeout(() => this.isFirstTimeUser(counter), 10);
    }
  }

  save() : void {
    if (!this.bulk) { // single items
  		this.firebaseService.createItemFromDescription(this.newItem);

      this.clearValues();
  	} else if (this.isList && this.saveRecipe && this.recipe && this.recipe !== '') { // bulk items & save recipe
      // in order to save a new recipe, we must send the current uid along as well
      this.firebaseService.uid
        .take(1)
        .subscribe(uid => {
          if (uid)
            this.firebaseService.createBulkItemsWithRecipe(uid, this.newItem, this.recipe);

          this.clearValues();
        });
    } else if (this.recipe && this.recipe !== '') { // bulk items w/o saving recipe
      this.firebaseService.createBulkItems(this.newItem, this.recipe, false);

      this.clearValues();
    } else { // bulk items w/o recipe
      this.firebaseService.createBulkItems(this.newItem);

      this.clearValues();
    }
  }

  clearValues() : void {
    this.newItem = this.recipe = null;
    this.saveRecipe = true;
  }
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/src/app/components/new-item/new-item.ts